import { CallLog } from '@/interfaces/ILogs';
import { safeJSONParse } from '@/utils/helper';
import { Ticket, TicketStatus } from './types';

/**
 * A helper function to validate the answers in a form.
 * It returns true if at least one answer is valid (not empty or 'N/A').
 */
const hasValidAnswers = (answers: { [key: string]: string }): boolean => {
	if (!answers || Object.keys(answers).length === 0) {
		return false;
	}
	return Object.values(answers).some(
		(answer) => answer && answer.trim() !== '' && answer.trim().toUpperCase() !== 'N/A',
	);
};

export const processLogsIntoTickets = (logs: CallLog[]): Ticket[] => {
	if (!logs) {
		return [];
	}

	const allTickets: Ticket[] = [];

	logs.forEach((log) => {
		if (!log.intakeResponses) {
			return;
		}

		const parsedForms = safeJSONParse(log.intakeResponses, []);
		const form = Array.isArray(parsedForms) ? parsedForms[0] : parsedForms;

		if (!form || typeof form !== 'object' || Object.keys(form).length === 0) {
			return;
		}

		if (!hasValidAnswers(form)) {
			return;
		}

		const metadata = safeJSONParse(log.intakeMetadata, {});

		let status: TicketStatus = 'OPEN';
		if (metadata.status && ['OPEN', 'IN_PROGRESS', 'COMPLETED'].includes(metadata.status)) {
			status = metadata.status;
		} else if (metadata.completed_at) {
			status = 'COMPLETED';
		}

		const ticket: Ticket = {
			id: `${log.callSid}_0`,
			status,
			note: metadata.note || '',
			answers: form,
			questions: Object.keys(form),
			transcript: log.transcript || '',
			callerPhone: log.from,
			callDate: log.date,
			completedAt: metadata.completed_at || null,
			inProgressAt: metadata.in_progress_at || null,
		};

		allTickets.push(ticket);
	});

	return allTickets;
};
